import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Input,
  Stack,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainModel from "../../../../components/Models/main-model";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  closeCreateStudent,
  openShowStudentDataModel,
} from "../../../../modules/admin-modules/models/Actions";
import { getPaymentExceptionRequest } from "../../../../modules/admin-modules/payment/Actions";
import {
  createStudentRequest,
  editStudentRequest,
} from "../../../../modules/admin-modules/students/Actions";
import {
  getSystemGovernmentRequest,
  getSystemGradesRequest,
  getSystemMajorsRequest,
  getSystemRegionRequest,
} from "../../../../modules/auth/Actions";
// import ShowPassword from '../models/show-password'

const colourStyles = (isValid) => {
  return {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      padding: "5px",
      borderRadius: "10px",
      boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
      border: isValid == "Required" ? "solid 1px red" : "solid 1px #0100108",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
};

const AddStudent = ({ isAdd, data, setSelectedData, setAddedStudent }) => {
  const openStudent = useSelector((state) => state.model.isOpen1);
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.students.isLoading);
  const paymentException = useSelector(
    (state) => state.payments.paymentException
  );
  const { governments, regions, grades, majors } = useSelector(
    (state) => state.auth
  );

  const dispatch = useDispatch();
  const errorStyle = (isValid) =>
    isValid == "Required" ? "red !important" : "#0100108 !important";

  const formik = useFormik({
    initialValues: data
      ? {
          ...data,
          student_group_id: data?.group?.id,
          payment_exception_id: data?.payment_exception?.id,
          gov_id: data?.governorate?.id,
          grade_id: data?.grade?.id,
          major_id: data?.major?.id,
          region_id: data?.region?.id,
        }
      : {},
    validateOnChange: true,
    onSubmit: (values) => {
      const editGroup = values?.student_group_id
        ? values?.student_group_id
        : data?.group?.id;
      
      const newDate = values?.reservation_date
        ? dayjs(values?.reservation_date).format("YYYY-MM-DD")
        : dayjs(data?.created_at).format("YYYY-MM-DD");

      const action = (data) => {
        dispatch(closeCreateStudent());
        setAddedStudent(data);
        dispatch(openShowStudentDataModel());
        setSelectedData({});
        formik.resetForm();
      };

      let formData = new FormData();
      for (let key in { ...values }) {
        formData.append(key, values[key]);
      }
      formData.append("reservation_date", newDate);
      formData.append("student_group_id", `${editGroup}`);

      if (isAdd) dispatch(createStudentRequest(formData, action));
      else {
        formData.append("_method", "PUT");
        dispatch(
          editStudentRequest({
            id: data?.id,
            formData: formData,
            action: () => {
              dispatch(closeCreateStudent());
            },
          })
        );
      }
    },
    enableReinitialize: true,
  });

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const paymentExceptionOptions = paymentException?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const governmentList = governments?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const regionsList = regions?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const gradesList = grades?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));
  const majorsList = majors?.map((val) => ({
    label: val?.name_ar,
    value: val?.id,
  }));

  useEffect(() => {
    if (openStudent) {
      dispatch(getAllGroupsRequest());
      dispatch(getPaymentExceptionRequest());
      dispatch(getSystemMajorsRequest());
      dispatch(getSystemGovernmentRequest());
      dispatch(getSystemGradesRequest());
    }
  }, [openStudent]);

  useEffect(() => {
    if (formik.values.gov_id)
      dispatch(getSystemRegionRequest(formik.values.gov_id));
  }, [formik.values.gov_id]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الطالب" : "تعديل  الطالب"}
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeCreateStudent());
    setSelectedData && setSelectedData({});
    formik.resetForm();
  };
  return (
    <>
      <MainModel
        header={header}
        closeFunc={closeFunc}
        openVar={openStudent}
        isLoading={isLoading}
        buttonFunc={() => {}}
      >
        <form onSubmit={formik.handleSubmit}>
          <Flex
            flexDirection="column"
            w="100%"
            gap={8}
            fontFamily="sans-serif"
            p={6}
            borderRadius={16}
          >
            <Stack flexDirection="row" gap={10}>
              <Box w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="name"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    اسم الطالب <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                </Flex>

                <Input
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "1px solid",
                    backgroundColor: "#fff",
                  }}
                  borderColor={errorStyle(formik?.errors.name)}
                  name="name"
                  size="lg"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  onBlur={formik.handleBlur}
                />
              </Box>
            </Stack>

            <Stack flexDirection="row" gap={10}>
              <Box w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="phone"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    رقم الموبايل <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                </Flex>

                <Input
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "1px solid",
                    backgroundColor: "#fff",
                  }}
                  name="phone"
                  borderColor={errorStyle(formik?.errors.phone)}
                  size="lg"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
              </Box>
              <Box w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="mother_phone"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    رقم موبايل ولي الأمر
                  </FormLabel>
                </Flex>

                <Input
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "1px solid",
                    backgroundColor: "#fff",
                  }}
                  name="mother_phone"
                  borderColor={errorStyle(formik?.errors.mother_phone)}
                  size="lg"
                  onChange={formik.handleChange}
                  value={formik.values.mother_phone}
                />
              </Box>
            </Stack>

            <Stack flexDirection="row" gap={10}>
              <Box w="100%">
                <Flex alignItems={"center"}>
                  <FormLabel
                    htmlFor="school"
                    className="form-label "
                    color="main_1"
                    fontSize="22px"
                    fontWeight="500"
                  >
                    المدرسة <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                </Flex>

                <Input
                  style={{
                    width: "100%",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 16px 0 rgba(0, 0, 0, 0.16)",
                    border: "1px solid",
                    backgroundColor: "#fff",
                  }}
                  name="school"
                  size="lg"
                  borderColor={errorStyle(formik?.errors.school)}
                  onChange={formik.handleChange}
                  value={formik.values.school}
                />
              </Box>
            </Stack>

            <Stack flexDirection="row" gap={10}>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px">
                  الصف الدراسي <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  options={gradesList}
                  styles={colourStyles(formik?.errors?.grade_id)}
                  defaultValue={{
                    label: data?.grade?.name_ar,
                    value: data?.grade?.id,
                  }}
                  placeholder="الصف الدراسي"
                  name="grade_id"
                  onChange={(val) =>
                    formik.setFieldValue("grade_id", val?.value)
                  }
                />
              </Box>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px">
                  الشعبة <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  options={majorsList}
                  styles={colourStyles(formik?.errors?.major_id)}
                  dir="rtl"
                  placeholder="الشعبة"
                  name="major_id"
                  onChange={(val) =>
                    formik.setFieldValue("major_id", val?.value)
                  }
                  defaultValue={{
                    label: data?.major?.name_ar,
                    value: data?.major?.id,
                  }}
                />
              </Box>
            </Stack>

            <Stack flexDirection="row" gap={10}>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px">
                  المحافظة <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  options={governmentList}
                  styles={colourStyles(formik?.errors?.gov_id)}
                  placeholder="المحافظة"
                  name="gov_id"
                  onChange={(val) => formik.setFieldValue("gov_id", val?.value)}
                  defaultValue={{
                    label: data?.governorate?.name_ar,
                    value: data?.governorate?.id,
                  }}
                />
              </Box>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px">
                  المنطقة <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  options={regionsList}
                  styles={colourStyles(formik?.errors?.region_id)}
                  dir="rtl"
                  placeholder="المنطقة"
                  name="region_id"
                  onChange={(val) =>
                    formik.setFieldValue("region_id", val?.value)
                  }
                  defaultValue={{
                    label: data?.region?.name_ar,
                    value: data?.region?.id,
                  }}
                />
              </Box>
            </Stack>

            <Stack flexDirection="row" gap={10}>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px">
                  المجموعة <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  options={groupsOptions}
                  styles={colourStyles(formik?.errors?.student_group_id)}
                  defaultValue={{
                    label: data?.group?.name,
                    value: data?.group?.id,
                  }}
                  placeholder="المجموعة"
                  name="student_group_id"
                  onChange={(val) =>
                    formik.setFieldValue("student_group_id", val?.value)
                  }
                />
              </Box>
              <Box w="100%" mt="0 !important">
                <FormLabel fontSize="22px"> النوع </FormLabel>
                <Select
                  options={[
                    { value: "male", label: "طالب" },
                    { value: "female", label: "طالبة" },
                  ]}
                  styles={colourStyles(formik?.errors?.gender)}
                  dir="rtl"
                  placeholder="النوع"
                  name="gender"
                  onChange={(val) => formik.setFieldValue("gender", val?.value)}
                  defaultValue={[
                    { value: "male", label: "طالب" },
                    { value: "female", label: "طالبة" },
                  ]?.find((val) => val?.value == data?.gender)}
                />
              </Box>
            </Stack>

            <Button
              mt="40px"
              mb="-25px"
              type="submit"
              w="200px"
              p="22px"
              alignSelf={"center"}
              isLoading={isLoading}
              bg="main_1"
              color="white"
            >
              {isAdd ? " إضافة الطالب" : "تعديل  الطالب"}
            </Button>
          </Flex>
        </form>
      </MainModel>

      {/* <ShowPassword data={studentData} /> */}
    </>
  );
};

export default AddStudent;
